var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.status === 'Active')?_c('v-chip',{attrs:{"color":"success","small":""}},[_vm._v(" Active ")]):_c('v-chip',{attrs:{"color":"error","small":""}},[_vm._v(" Expired ")])
}
var staticRenderFns = []

export { render, staticRenderFns }